import { type Segment } from '../types';

export const sortSegments = (segments: Segment[]): Segment[] => {
  return segments.sort((a, b) => a.threshold - b.threshold);
};
